export default __webpack_public_path__ + "static/media/I.222018a7.jpg";